import React    from 'react';
import Lightbox from 'react-image-lightbox';

export default class GalleryLightbox extends React.Component {
  constructor(props) {
    super(props);
    this.id = this.props.id;
    this.state = {
      images: this.props.images,
      imageIndex: 0,
      isOpen: false
    };
  }

  componentDidMount() {
    $(document).on('clickImage.gallery', this.show)
  }

  componentWillUnmount() {
    $(document).on('clickImage.gallery', this.show)
  }

  show = (event, id, index) => {
    if (id != this.id) return;
    this.setState({ isOpen: true, imageIndex: index });
  }

  render() {
    const images = this.state.images;
    const imageIndex = this.state.imageIndex
    var nextIndex = imageIndex + 1
    if (nextIndex >= images.length) nextIndex = null;
    var prevIndex = imageIndex - 1
    if (prevIndex < 0) prevIndex = null;

    return (
      <div>
        {this.state.isOpen &&
          <Lightbox
            mainSrc={images[imageIndex]}
            nextSrc={images[nextIndex]}
            prevSrc={images[prevIndex]}

            onCloseRequest={() => this.setState({ isOpen: false })}
            onMoveNextRequest={() => this.setState({ imageIndex: nextIndex })}
            onMovePrevRequest={() => this.setState({ imageIndex: prevIndex })}

            enableZoom={false}
            imagePadding={40}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/gallery_lightbox.jsx